module.exports = __webpack_public_path__ + "static/img/step3.b70565c8.png";